'use client';

import { useRef } from 'react';
import type { TerraUIMessage } from '@terra/shared-dto-chat-types';
import {
  resolveNeoAttackTrackingState,
  type NeoAttackTrackingStateCache,
} from '../utils/message-processing';

export type ChatNeoAttackTrackingState = {
  hasActiveNeoAttackTracking: boolean;
  neoAttackTrackingIdentity: string;
};

export function useChatHasActiveNeoAttackTracking(
  messages: TerraUIMessage[],
): ChatNeoAttackTrackingState {
  const cacheRef = useRef<NeoAttackTrackingStateCache | null>(null);
  const resolved = resolveNeoAttackTrackingState({
    messages,
    cache: cacheRef.current,
  });
  cacheRef.current = resolved.cache;
  return {
    hasActiveNeoAttackTracking: resolved.hasActiveNeoAttackTracking,
    neoAttackTrackingIdentity: resolved.neoAttackTrackingIdentity,
  };
}
